import styled from 'styled-components';

type GridContainerProps = {
    columns?: string;
    rows?: string;
};

const GridContainer = styled.div<GridContainerProps>`
    display: grid;
    grid-template-columns: ${(props) => `repeat(${props.columns ?? 1 }, 1fr)`};
    grid-template-rows: ${(props) => props.rows ?? 'auto'};
`;

export const GridCardContainer = styled(GridContainer)`
    grid-template-areas: 'header' 'body' 'footer';
    row-gap: 2rem;
`;

export default GridContainer;
